<template>
    <tr>
        <td v-bind:data-th="$t('site.name')">
            {{name}} <span class="badge badge-info">{{type}}</span><br />
            <span class="small">{{location}}</span>
        </td>
        <td v-bind:data-th="$t('site.last_check_timestamp')">
          {{lastCheckedDate}}
        </td>
        <td class="text-center">
          <font-awesome-icon v-if="!enabled && processing === 1" :icon="['fal','spinner']" pulse></font-awesome-icon>
          <button v-else-if="!enabled" v-on:click="localEnableUpdateSite()" class="btn btn--primary">
            {{$t('site.enable')}}
          </button>
          <font-awesome-icon v-else class="text--success" :icon="['fal','check-circle']"></font-awesome-icon>
        </td>
    </tr>
</template>

<script>

import { mapActions, mapState } from 'vuex'

import mixins from '../../mixins'
import moment from 'moment/moment'

export default {

  name: 'SiteDetailUpdatesiteItem',

  mixins: [mixins],

  data () {
    return {
      processing: 0
    }
  },

  props: [
    'id',
    'name',
    'type',
    'location',
    'enabled',
    'last_check_timestamp'
  ],

  computed: {
    ...mapState('user', [
      'userTimezone'
    ]),

    lastCheckedDate () {
      if (!this.last_check_timestamp) {
        return '-'
      }

      return moment
        .unix(this.last_check_timestamp)
        .add(parseInt(this.userTimezone), 'hours')
        .format('DD.MM.YYYY HH:mm')
    }
  },

  methods: {
    ...mapActions('updatesite', [
      'enableUpdateSite'
    ]),

    localEnableUpdateSite () {
      this.enableUpdateSite(this.id)
      this.processing = 1
    }
  }
}
</script>
